export const type= 'actualizarJson';
const actualizarJson=(generalJson)=>{
    return{
        type,
        payload: generalJson.generalJson,
    }
}
export default actualizarJson;